{
    "ALERT": {
        "ERROR": {
            "MESSAGE": {
                "NOT_FOUND": "The item was not found"
            },
            "TITLE": "Error"
        },
        "SUCCESS": {
            "MESSAGE": {
                "CREATE": "The creation was processed successfully",
                "EDIT": "The edition was processed successfully",
                "DELETE": "The deletion was processed successfully",
                "REFUND": "The refund was processed successfully",
                "SEND_RESET_PIN": "The email was sent successfully",
                "STATUS_CHANGED": "The status change was processed successfully",
                "UPLOAD": "Upload was completed successfully",
                "DELETE_SUBSCRIPTION": "Subscription has been deleted"
            },
            "TITLE": "Success"
        }
    },
    "BUTTON": {
        "NO": "No",
        "YES": "Yes",
        "DETAIL": "Detail",
        "DELETE": "Delete",
        "LOCATE": "Reset marker",
        "EDIT": "Edit",
        "SAVE": "Save",
        "CANCEL": "Cancel",
        "CANCEL_SUBSCRIPTION": "Cancel subscription",
        "ADD_CAR": "Add a car",
        "ADD_TERMINAL": "Add a terminal",
        "ADD_LINK": "Add a link",
        "ADD_PERIOD": "Add a schedule",
        "CREATE_STATION": "Create a station",
        "ADD": "Add",
        "CREATE": "Create",
        "VIEW_REAL_TIME": "View in real time",
        "ADD_IMAGE": "Add an image",
        "DELETE_IMAGE": "Delete an image",
        "SHOW_SUBSCRIPTION": "View active subscriptions",
        "RESTART": "Restart",
        "REFRESH": "Refresh",
        "SET": "Set"
    },
    "COLUMNS": {
        "DETAILS": "Details",
        "STATION_NAME": "Station name",
        "CONNECTOR_ID": "Connector ID",
        "CITY": "City",
        "FIRST_NAME": "First name",
        "LAST_NAME": "Last name",
        "EMAIL": "Email",
        "PHONE_NUMBER": "Phone number",
        "STREET": "Street",
        "NAME": "Name",
        "TERMINALS": "Terminals",
        "TERMINAL_NAME": "Terminal name",
        "STATUS": "Status",
        "LEVEL": "Level",
        "BREAKER": "Breaker",
        "NUMBER": "Nb. of Terminals",
        "COST": "Cost",
        "VOLTAGE": "Voltage",
        "DAY_OF_THE_WEEK": "Day of the week",
        "PERCENTAGE": "Percentage",
        "TOTAL_CHARGE": "Total charge",
        "AMPERAGE": "Amperage",
        "ACCESS": "Access",
        "STATE_OF_CHARGE": "State of charge",
        "SESSION_DURATION": "Session duration",
        "TOTAL": "Total $",
        "ENERGY_CONSUMED": "Energy consumed",
        "BARCODE": "Barcode",
        "START_DATE": "Start date",
        "END_DATE": "End date",
        "VISIBLE": "Visible",
        "SUBSCRIPTION": "Subscription",
        "IS_ACTIVE": "Active",
        "NOT_ACTIVE": "Not Active",
        "POWER": "Power",
        "SERIAL_NUMBER": "Serial Number",
        "ACCESS_MODE": "Access Mode",
        "ACCESS_TYPE": "Access Type",
        "ESTIMATED_COST": "Estimated Electricity Cost (¢)",
        "FIRMWARE_VERSION": "Firmware Version",
        "MAC_ADDRESS": "MAC Address",
        "WIFI_RSSI": "WiFi RSSI",
        "LOCAL_IP_ADDRESS": "Local IP Address",
        "MINIMUM_SESSION_DURATION": "Minimum Session Duration",
        "DEFAULT_SESSION_DURATION": "Default Session Duration",
        "MAXIMUM_SESSION_DURATION": "Maximum Session Duration",
        "RESTART": "Restart",
        "REFRESH": "Refresh",
        "VALUE": "Value",
        "DAYS": "Days",
        "HOURS": "Hours"
    },
    "DIALOG": {
        "CHANGE_PASSWORD": {
            "TITLE": "Change your password"
        },
        "CONFIRM_ACTION": {
            "TITLE": "Confirmation",
            "MESSAGE": "Are you sure that you wish to execute this action?"
        },
        "CONFIRM_BONUS_EXPIRATION_DATE": {
            "TITLE": "Confirmation of the expiration date of the bonus",
            "MESSAGE": "This action will change the warranty date for: {{bonusDate}} ? "
        },
        "DISABLE": {
            "TITLE": "Disable an item",
            "MESSAGE": "Do you really want to disable this item ?"
        },
        "LOGO": {
            "TITLE": "Upload a logo"
        },
        "UNSAVED_CHANGES": {
            "TITLE": "Unsaved changes",
            "MESSAGE": "You have unsaved changes, are you sure that you wish to discard them?"
        }
    },
    "FEEDBACK": {
        "MESSAGE": {
            "ERROR": {
                "403": "You do not have permission to view this page",
                "404": "Page not found",
                "500": "Internal server error",
                "AN_ERROR_OCCURRED": "An error occurred try again later",
                "CARD_ALREADY_USE": "This card is already use.",
                "CARD_WAITING": "The card is waiting for activation by the customer.",
                "CREATE": "There was an error while creating the item.",
                "DISABLE": "There was an error while disabling the item.",
                "EDIT": "There was an error while editing the item.",
                "EMPTY_LIST": "{{type}} list is empty",
                "NOT_FOUND": "{{field}} not found",
                "NOT_SET": "{{field}} not set"
            },
            "IMAGE_SIZE": "Image size ({{width}}x{{height}}) is not optimal",
            "SUCCESS": {
                "CREATE": "The item was created successfully.",
                "DISABLE": "The item was disabled successfully.",
                "EDIT": "The item was edited successfully.",
                "UPLOAD": "Your image was upload successfully"
            },
            "UNSAVED": {
                "TITLE": "Unsaved changes",
                "MESSAGE": "Do you really want to cancel unsaved changes ?"
            }
        },
        "VALIDATION": {
            "ERROR": {
                "104": "Username or password is invalid",
                "IMAGE_SIZE": "Image size ({{width}}x{{height}}) is invalid",
                "PASSWORD_MATCH": "The passwords do not match",
                "PATTERN": "{{field}} is invalid",
                "REQUIRED": "{{field}} is required",
                "NOT_NUMBER": "{{field}} is not a number",
                "TYPE": "Type is required",
                "IMAGE": {
                    "UPLOAD": "There was a error while uploading the image {{error}}"
                }
            }
        }
    },
    "FIELD": {
        "ID": {
            "TITLE": "Id"
        },
        "BARCODE": {
            "TITLE": "Codebar"
        },
        "CATEGORY": {
            "TITLE": "Category"
        },
        "EMAIL": {
            "TITLE": "Email or Phone number",
            "PLACEHOLDER": "Email or Phone number",
            "NOTIFICATION": {
                "TITLE": "Email notification"
            }
        },
        "NAME": {
            "TITLE": "Name"
        },
        "INFOS": {
            "TITLE": "Infos"
        },
        "VISIBLE": {
            "TITLE": "Is visible"
        },
        "DATE": {
            "START": {
                "TITLE": "Start date"
            },
            "END": {
                "TITLE": "End date"
            }
        },
        "STATION": {
            "NAME": {
                "TITLE": "Station name"
            },
            "NAMES": {
                "TITLE": "Station names"
            }
        },
        "WEBSITE": {
            "TITLE": "Website"
        },
        "PHONE_NUMBER": {
            "TITLE": "Phone number"
        },
        "STATIONS": {
            "TITLE": "Stations"
        }
    },
    "HEADER": {
        "LOGOUT": "Log out",
        "PROFILE": "Profile",
        "TOGGLE_MENU": "Toggle menu"
    },
    "LABEL": {
        "ADDRESS": "Address",
        "FIRST_NAME": "First name",
        "LAST_NAME": "Last name",
        "EMAIL": "Email",
        "NAME": "Name",
        "COLOR": "Color",
        "YEAR": "Year",
        "PHONE_NUMBER": "Phone number",
        "POSTAL_CODE": "Postal code",
        "COUNTRY": "Country",
        "BALANCE": "Balance",
        "STREET": "Street",
        "CITY": "City",
        "STATE": "State",
        "STATUS": "Status",
        "SUITE": "Suite",
        "CHARGE_BOX_IDENTITY": "Charge box identity",
        "COST": "Cost",
        "TIME_IN_MINUTES": "Time in minutes",
        "VOLTAGE": "Voltage",
        "AMPERAGE": "Amperage",
        "ADD_CONNECTOR": "Add connector",
        "LEVEL": "Level",
        "LANGUAGE": "Language",
        "ID": "Id",
        "STATION": "Station",
        "VISIBLE": "Visible",
        "INFOS": "Infos",
        "START_DATE": "Start date",
        "END_DATE": "End date",
        "SUBSCRIPTION": "Subscription",
        "IMAGE_UPLOADER": "Station image"
    },
    "LOGIN": {
        "TITLE": "Log in",
        "SIGN_IN": "Sign in",
        "PASSWORD": {
            "TITLE": "Password",
            "PLACEHOLDER": "********"
        },
        "FORGOT_PASSWORD": "Forgot your password"
    },
    "PLACEHOLDERS": {
        "SEARCH": "Search"
    },
    "HOME": {
        "TITLE": "Home"
    },
    "REPORTS": {
        "TITLE": "Reports",

        "SESSION_HISTORY": {
            "TITLE": "Session History"
        }
    },
    "STATIONS": {
        "DETAIL": {
            "TERMINALS_LIST": "Terminals list",
            "LINKS_LIST": "Links list",
            "PERIODS_LIST": "Schedules list",
            "TITLE": "Station detail"
        },
        "CREATE": {
            "TITLE": "Create station",
            "CREATE": "Create"
        },
        "EDIT": {
            "TITLE": "Edit station",
            "EDIT": "Edit"
        },
        "LIST": {
            "TITLE": "Stations list"
        },
        "TERMINAL": {
            "CREATE": {
                "TITLE": "Create terminal"
            },
            "EDIT": {
                "TITLE": "Edit terminal"
            }
        },
        "TITLE": "Stations"
    },
    "USERS": {
        "DETAIL": {
            "CARS_LIST": "Cars list",
            "TITLE": "User detail"
        },
        "EDIT": {
            "TITLE": "Edit user",
            "EDIT": "Edit"
        },
        "LIST": {
            "TITLE": "Users list"
        },
        "TITLE": "Users"
    },
    "SETTINGS": {
        "TITLE": "Settings"
    },
    "LINKS": {
        "LINK":"Links",
        "LEVEL":"Level",
        "BREAKER":"Breaker"
    },
    "COMMON": {
        "EDIT": "Edit",
        "LANGUAGE": "Language",
        "CREATE": "Create"
    },
    "ADD_IMAGE": {
        "DESCRIPTION": "Choose a PNG/JPEG file that has a minimum of {{width}} pixels in width and {{height}} pixels in height.",
        "FORMAT_INVALID": "Image format is invalid",
        "TITLE": "Upload an Image",
        "SIZE_ERROR": "Image size ({{width}}x{{height}}) is invalid"
    },
    "REPORT":
    {
        "MONTH": "Month",
        "FORMAT": "Report format",
        "DOWNLOAD_PDF": "Download as PDF",
        "DOWNLOAD_CSV": "Download as CSV"
    },
    "STATUS":
    {
        "AVAILABLE": "Available",
        "IN_USE": "In use",
        "PENDING": "Waiting for connection",
        "OUT_OF_SERVICE": "Out of service",
        "UNKNOWN": "Not-connected"
    },
    "GRID_PAGER":
    {
        "ITEMS":"items",
        "OF":"of"
    },
    "AUTOCOMPLETE":
    {
        "PLACEHOLDER":"Location"
    },
    "IMAGE_UPLOADER":
    {
        "NO_IMAGE":"Upload an image"
    },
    "SCHEDULE_PERIOD":
    {
        "TYPE":
        {
            "ACCESS":"Access",
            "STATUS":"Status",
            "POWER_LIMITATION":"Power Limitation",
            "COST":"Cost"
        },
        "PUBLIC":"Public",
        "PRIVATE":"Private",
        "OUT_OF_SERVICE":"Out of service"
    },
    "WEEKDAYS":
    {
        "MONDAY":"Monday",
        "TUESDAY":"Tuesday",
        "WEDNESDAY":"Wednesday",
        "THURSDAY":"Thursday",
        "FRIDAY":"Friday",
        "SATURDAY":"Saturday",
        "SUNDAY":"Sunday"
    },
    "INVITATION":
    {
        "OWNERSHIP_TRANSFER":"Ownership transfer: ",
        "ERROR":"error",
        "COMPLETED":"completed",
        "ERROR_LABEL":"The following error occurred:",
        "CLOSE_WEBPAGE":"You can close this web page.",
        "DESCRIPTION_1":" would like to transfer ownership of the station ",
        "DESCRIPTION_2":" located at ",
        "DESCRIPTION_3":",  and the terminals it contains to you.",
        "DELETE_GUESTS":"Delete the guests currently present in this station",
        "KEEP_CURRENT_OWNER_ACCESS":"Keep the current owner as a guest of this station",
        "ACCOUNT_INSTRUCTIONS_1":"At least one of the terminals contained in this station is of the Paying type.",
        "ACCOUNT_INSTRUCTIONS_2":"To complete the transfer of ownership of this station, a valid payout account must be added to your EVduty account.",
        "ACCOUNT_INSTRUCTIONS_3":"To add a payout account to your EVduty account:",
        "ACCOUNT_INSTRUCTIONS_4":"EVduty mobile app → Profile → Payouts",
        "ACCOUNT_INSTRUCTIONS_5":"Once the payout account has been added, the transfer of ownership can be completed.",
        "ACCEPT":"Accept",
        "DECLINE":"Decline",
        "DECLINED":"invitation declined",
        "DECLINED_DESCRIPTION_1":"You ",
        "DECLINED_DESCRIPTION_2":"declined",
        "DECLINED_DESCRIPTION_3":" the request to transfer ownership of the station ",
        "DECLINED_DESCRIPTION_4":" sent by ",
        "DECLINED_DESCRIPTION_5":"We will notify the current owner.",
        "COMPLETED_DESCRIPTION_1":"You have accepted the transfer of ownership request for the station ",
        "COMPLETED_DESCRIPTION_2":" sent by ",
        "COMPLETED_DESCRIPTION_3":"The transfer was ",
        "COMPLETED_DESCRIPTION_4":"successful",
        "COMPLETED_DESCRIPTION_5":"You can now access this station from the ",
        "COMPLETED_DESCRIPTION_6":"EVduty mobile app",
        "COMPLETED_DESCRIPTION_7":" in the ",
        "COMPLETED_DESCRIPTION_8":"My Stations",
        "COMPLETED_DESCRIPTION_9":" tab."
    },
    "SCHEDULES":
    {
        "SCHEDULE":"Schedule",
        "START_TIME":"Start Time",
        "END_TIME":"End Time",
        "DAYS":"Days",
        "LINKED_TERMINALS":"Schedule linked terminals",
        "ACCESS_TYPE":"Schedule Type",
        "OUT_OF_SERVICE":"Out of Service",
        "PUBLIC":"Public",
        "POWER_TYPE":"Limit type",
        "TIME":"Time",
        "ALTERNATE_COST":"Alternate Cost",
        "DELAY":"Delay"
    },
    "POWER_TYPE":
    {
        "AMPERES":"Amperes",
        "WATTS":"Watts"
    },
    "FOR":"for",
    "AFTER":"after",
    "TO":"to",
    "FREE":"Free"
}
